const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export function mountScrollStack(root = document) {
	const stack = root.querySelector("[data-scroll-stack]");
	if (!stack || window.matchMedia("(max-width: 899px), (prefers-reduced-motion: reduce)").matches) {
		return () => {};
	}

	const cards = [...stack.querySelectorAll(":scope > .solufy-pillar-card")];
	cards.forEach((card, index) => {
		card.style.setProperty("--stack-index", index);
		card.style.setProperty("--stack-depth", cards.length - index - 1);
	});

	let frame = 0;
	const update = () => {
		const top = 92;
		cards.forEach((card, index) => {
			const next = cards[index + 1];
			const progress = next
				? clamp((top + 150 - next.getBoundingClientRect().top) / 260, 0, 1)
				: 0;
			card.style.setProperty("--stack-progress", progress.toFixed(3));
		});
		frame = 0;
	};
	const requestUpdate = () => {
		if (!frame) frame = requestAnimationFrame(update);
	};

	update();
	window.addEventListener("scroll", requestUpdate, { passive: true });
	window.addEventListener("resize", requestUpdate, { passive: true });

	return () => {
		if (frame) cancelAnimationFrame(frame);
		window.removeEventListener("scroll", requestUpdate);
		window.removeEventListener("resize", requestUpdate);
	};
}
